import PercentageToGoal from './PercentageToGoal';
export default PercentageToGoal;